import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-question-card',
  templateUrl: './question-card.component.html',
  styleUrls: ['./question-card.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionCardComponent {
  constructor(private sanitizer: DomSanitizer) {}

  SanitizeHTML(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html || '');
  }
  @Input() question: any;
  @Input() relocateQuestions: boolean = false;
  @Input() preSelectQuestions: boolean = false;
  @Input() editQuestions: boolean = false;
  @Input() index: number = 0;
  @Input() selectedCourse: null | {
  courseId: string
  examAgencyId: string
  courseName: string
  examYear: string
} = null;


  @Output() editClicked = new EventEmitter<any>();
  @Output() relocateCheckboxChanged = new EventEmitter<any>();
  @Output() preEvalCheckboxChanged = new EventEmitter<any>();

  ngOnInit(){
    console.log(this.question);

  }

  triggerEdit() {
    this.editClicked.emit(this.question);
  }

  onRelocateChange() {
    this.relocateCheckboxChanged.emit({ question: this.question, selected: this.question.selectedForRelocation });
  }

onPreEvaluateQuestionChange() {
  if (!this.selectedCourse) {
    this.question.selectedForPreEvaluation = false;
    return;
  }

  this.preEvalCheckboxChanged.emit({
    question: this.question,
    selected: this.question.selectedForPreEvaluation
  });
}


  printQuestionDetails() {
    const arr = this.question.previouslyAppearedDescriptions ;
    const str = arr.join(", ");
    return str ? '('+str+')' :'' ;
  }
}
